import { render } from "./MainLoader.vue?vue&type=template&id=7c9fb3c1&scoped=true"
import script from "./MainLoader.vue?vue&type=script&lang=js"
export * from "./MainLoader.vue?vue&type=script&lang=js"

import "./MainLoader.vue?vue&type=style&index=0&id=7c9fb3c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9fb3c1"]])

export default __exports__